import { useEffect } from "react";
import { useLocation, useNavigationType } from "react-router-dom";

// Global scroll-to-top on real page navigation.
// - Keyed on pathname only (search/hash changes do NOT trigger it).
// - Skips browser back/forward (POP) so restored positions are preserved.
// - Skips hash anchors (#...) and ?comment= deep-links so their own scroll wins.
export default function ScrollToTop() {
  const { pathname, hash, search } = useLocation();
  const navigationType = useNavigationType();

  useEffect(() => {
    if (navigationType === "POP") return;
    if (hash) return;
    if (new URLSearchParams(search).has("comment")) return;
    window.scrollTo(0, 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return null;
}
